@if (!this.loading && !gateway) {
  <app-breadcrumb
    listado="/main/administracion/gateways"
    etiquetaListado="Gateways"
    [titulo]="gateway?.nombre"
  ></app-breadcrumb>
  <app-empty-state
    icon="podcasts"
    message="No se encontró el gateway"
  ></app-empty-state>
} @else if (!this.loading && gateway) {
  <app-breadcrumb
    listado="/main/administracion/gateways"
    etiquetaListado="Gateways"
    [titulo]="gateway?.nombre"
  ></app-breadcrumb>

  <!-- Encabezado con la misma estética que las tarjetas de la pestaña Info -->
  <header class="encabezado">
    <div class="encabezado-avatar"><mat-icon>podcasts</mat-icon></div>
    <div class="encabezado-texto">
      <h1>{{ gateway.nombre }}</h1>
      @if (gateway.gatewayEui) {
        <span class="encabezado-nombre encabezado-eui">
          {{ gateway.gatewayEui }}
        </span>
      }
      <div class="encabezado-chips">
        @if (gateway.cliente?.nombre) {
          <span class="chip">
            <mat-icon>business</mat-icon>
            {{ gateway.cliente.nombre }}
          </span>
        }
        @if (gateway.autoCreado) {
          <!-- Lo dio de alta el cron de métricas, no un usuario -->
          <span class="chip">Creado automáticamente</span>
        }
      </div>
    </div>
    <!-- Mismo permiso que pide el listado para editar -->
    @if (puedeEditar) {
      <button
        irxBotonIcono
        class="encabezado-editar"
        (click)="editar()"
        tooltip="Editar gateway"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
  </header>

  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedTabChange)="tabChanged($event)"
    class="tabs-detalle"
  >
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">info</mat-icon>
        <span>Info</span>
      </ng-template>
      <ng-template matTabContent>
        <app-detalles-gateway-info
          [gateway]="gateway"
          [metricas]="metricas"
          [airtime]="airtime"
        ></app-detalles-gateway-info>
      </ng-template>
    </mat-tab>

    <!-- Los gráficos, que antes iban debajo de la info -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">analytics</mat-icon>
        <span>Métricas</span>
      </ng-template>
      <ng-template matTabContent>
        <app-detalles-gateway-metricas
          [gateway]="gateway"
          [metricas]="metricas"
          [airtime]="airtime"
        ></app-detalles-gateway-metricas>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
} @else {
  <app-detalle-esqueleto
    icono="podcasts"
    listado="/main/administracion/gateways"
    etiquetaListado="Gateways"
    [pestanas]="2"
  ></app-detalle-esqueleto>
}
